import React, { useEffect, useRef, useState } from 'react';

export default function AdBanner({ slot, format = 'auto', style = {} }) {
    const adRef = useRef(null);
    const [adFailed, setAdFailed] = useState(false);

    useEffect(() => {
        const loadAd = () => {
            try {
                if (window.adsbygoogle) {
                    window.adsbygoogle.push({});
                }
            } catch (error) {
                console.warn('Google Ads non disponible:', error);
                setAdFailed(true);
            }
        };

        const timer = setTimeout(loadAd, 500);
        return () => clearTimeout(timer);
    }, []);

    if (adFailed) {
        return (
            <div className="ad-fallback" style={style}>
                <div className="ad-fallback-content">
                    <span className="ad-fallback-icon">💻</span>
                    <div>
                        <h4>Espace Publicitaire</h4>
                        <p>Contactez-nous pour placer votre annonce ici</p>
                        <a href="/contact" className="ad-fallback-link">
                            En savoir plus →
                        </a>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="ad-banner-wrapper" style={style}>
            <div className="ad-banner-container">
                <ins
                    className="adsbygoogle"
                    style={{ display: 'block' }}
                    data-ad-client="ca-pub-9945179968237831"
                    data-ad-slot={slot}
                    data-ad-format={format}
                    data-full-width-responsive="true"
                    ref={adRef}
                ></ins>
                <div className="ad-label">Sponsorisé</div>
            </div>
        </div>
    );
}